<template>
    <div class="container">
        <!-- <div class="coopbg">
            <div class="cooptitle">
                <h1>合作客户</h1>
                <span>COOPERATIVE&nbsp;&nbsp;&nbsp;&nbsp;CUSTOMERS</span>
            </div>
        </div>
        <div class="navcontainer">
            <div class="navmain">
                <span>首页</span>
                <span>/</span>
                <span @click="goback">客户案例</span>
                <span>/</span>
                <span style="color:rgb(73,129,243)">合作客户</span>
            </div>
        </div> -->
        <div class="coopMain">
            <div class="cooptitle">
                <ul>
                    <li><img src="../../assets/images/adicon.png"/></li>
                    <li><h1>合作客户</h1></li>
                    <li><img src="../../assets/images/adicon.png"/></li>
                </ul>
            </div>
            <div class="coopbody">
                <div class="coopcontent">
                    <div class="coopitem" v-for="item in coopInfo" :key="item.id">
                        <a><img :src="item.imagePath"/></a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import axios from 'axios'
export default {
    data() {
        return{
            coopInfo:[]
        }
    },
    methods:{
        goback(){
            this.$router.push('/cusCase/index')
        },
        getCoopCusInfo(){
            axios.get('http://www.thingo.com.cn/thingo-server/website/homePage/partner').then((res) => {
                this.coopInfo = res.data.data;
                this.coopInfo.forEach(item => {
                  if (item.linkUrl.slice(0,1) != 'h') {
                    item.linkUrl = 'https://' + item.linkUrl
                  }
                })
            })
        }
    },
    mounted(){
        this.getCoopCusInfo()
    }
}
</script>

<style scoped>
    .navcontainer{
        width: 100%;
        height: 50px;
        background-color: rgb(246,248,251);
    }
    .navcontainer .navmain{
        width: 300px;
        height: 50px;
        display: flex;
        align-items: center;
        position: relative;
        left: 200px;
    }
    .navcontainer .navmain span{
        font-family: 'PingFang SC', 'PingFang SC-Regular';
        margin-right: 5px;
        font-size: 16px;
        cursor: pointer;
    }
    .coopMain{
        width: 100%;
        height: auto;
        padding-bottom: 100px;
    }
    .coopMain .coopbody{
        width: 90%;
        height: auto;
        margin: 0 auto;
        margin-bottom: 100px;
    }
    .coopMain .cooptitle{
        width: 300px;
        height: 100px;
        margin: 0 auto;
        position: relative;

        text-align: center;
    }
    .coopMain .cooptitle ul{
        margin: 0;
        padding: 0;
    }
    .coopMain .cooptitle ul li {
        list-style: none;
        display: inline-block;
        margin-left: 10px;
        margin-right: 10px;
        color: #000000;
    }
    .coopMain .coopcontent{
        position: relative;
        width: 100%;
        height: auto;
        margin: 0 auto;
        text-align: center;
    }
    .coopMain .coopcontent .coopitem{
        width: 280px;
        height: 130px;
        margin: 15px 15px;
        display: inline-block;
        overflow: hidden;
        border: 1px solid rgb(228,229,229);
        transition: all 0.7s;
    }
    .coopMain .coopcontent .coopitem:hover{
        border: 1px solid rgb(38,110,210);
    }
    .coopMain .coopcontent .coopitem img{
        transform: scale(1,1);
        transition: all 0.7s;
        width: 100%;
        height: 100%;
    }
    .coopMain .coopcontent .coopitem img:hover{
        transform: scale(1.1,1.1);
    }
</style>
